/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * ViewModel surface for the DEBUG-ONLY Feature Override screen.
 */

export { default as featureOverrideReducer } from "./featureOverrideSlice";
export {
  openFeatureOverride,
  cycleFeatureOverride,
  resetAllFeatureOverrides,
  resetAllStageOverrides,
  setRowOverride,
  setRowStageOverride,
  closeFeatureOverride,
  focusNextControl,
  focusPrevControl,
  setFocusedControl,
  selectIsFeatureOverrideVisible,
  selectFeatureOverrideRows,
  selectFeatureOverrideFocusedIndex,
  selectFocusedControl,
  selectResetStageOverridesIndex,
  selectResetFeatureOverridesIndex,
  selectVideoDebugOverlayControlIndex
} from "./featureOverrideSlice";
export {
  CONTROLS_PER_ROW,
  EXTRA_CONTROL_COUNT,
  RESET_CONTROL_COUNT,
  getActivationControlIndex,
  getControlCount,
  getResetActivationIndex,
  getResetStageIndex,
  getStageControlIndex,
  getVideoDebugOverlayIndex,
  resolveControl
} from "./featureOverrideControls";
export { FeatureOverrideControlKind } from "./featureOverride.types";
export type {
  FeatureOverrideState,
  TFeatureOverrideControl,
  TFeatureOverrideRow,
  TFeatureOverrideCycleDirection
} from "./featureOverride.types";
export { isDevToolsBuild } from "../../devtools/appVersionOverride";
